import { reduxForm } from 'redux-form'
import FormWrapper from 'shared/components/form-wrapper'
import { IUserFormValues, IUserFormWrapper } from './UserForm.types'
import { UserFormAdapter } from 'secure-pages/users/user-form/UserForm.constants'
import validate from './UserForm.validate'

export default reduxForm<IUserFormValues, IUserFormWrapper>({
  form: UserFormAdapter.name,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate
})(FormWrapper)
